module.exports = __webpack_public_path__ + "static/media/img4.c0cd075a.jpg";